import { SUBMIT_FIRST_LOGIN_ASYNC } from './constants'

const initialState = {
  loader: false,
  message: null,
  status: null,
  error: null,
  success: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_FIRST_LOGIN_ASYNC.INITIATE:
      return {
        ...state,
        loader: true,
        success: null,
      }
    case SUBMIT_FIRST_LOGIN_ASYNC.ERROR:
      return {
        ...state,
        error: action.error,
        isValid: false,
        loader: false,
        success: false,
      }
    case SUBMIT_FIRST_LOGIN_ASYNC.SUCCESS:
      return {
        ...state,
        success: true,
      }
    default:
      return state
  }
}
